import React from 'react';
import {createUseStyles} from 'react-jss';

import {COLORS} from '../../utils/style-variables';

const useStyles = createUseStyles({
  headerText: {
    color: COLORS.blackColor,
    margin: 0,
    position: 'relative',
    display: 'inline-block',
    fontSize: '21px',
    fontWeight: 700,
    lineHeight: '114.286%',
    fontStyle: 'normal',
    letterSpacing: '-0.42px'
  }
});

export const WidgetH1 = ({text}) => {
  const classes = useStyles();

  return (<h1 className={classes.headerText}>{text}</h1>);
};
